import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { alteAdresseZiel } from './seiten';

/**
 * #483 2b: Alte Adressen (`/benutzer?tab=…`, `/users`, `/email-verteiler`) auf die neuen unter `/personen` —
 * mit Reiter aus dem Query-Parameter, den ein einfaches `<Navigate>` nicht auswerten kann.
 */
const AlteAdresse: React.FC = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={alteAdresseZiel(pathname, search) ?? '/events'} replace />;
};

export default AlteAdresse;
